module.exports = __webpack_public_path__ + "static/img/Jake.Carlisle.505709d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jake.Carlisle.jpg
// module id = eCuk
// module chunks = 0